<app-login-layout>
    <app-forgot-password-form></app-forgot-password-form>
</app-login-layout>
